import React from 'react';

export const BullMark = ({ className = 'h-9', light = false }) => (
  <img src="/bull-240.webp" alt="" aria-hidden="true" width="240" height="111" className={`w-auto ${light ? 'brightness-0 invert opacity-90' : ''} ${className}`} />
);

export const BrandLockup = ({ light = false, compact = false }) => (
  <span className="flex items-center gap-3">
    <BullMark light={light} className={compact ? 'h-8' : 'h-9 md:h-11'} />
    <span className={`flex flex-col border-l pl-3 ${light ? 'border-tan/50' : 'border-tan'}`}>
      <span className={`font-serif text-[1.3rem] font-semibold leading-none tracking-[0.07em] md:text-[1.55rem] ${light ? 'text-bone-light' : 'text-kombu-green'}`} data-testid="brand-wordmark">
        BULLISH
      </span>
      <span className={`mt-1.5 text-[8px] font-semibold tracking-[0.24em] md:text-[8.5px] ${light ? 'text-tan' : 'text-moss-green'}`}>
        TAX &amp; ADVISORY
      </span>
    </span>
    <span className="sr-only">BULLISH Tax &amp; Advisory</span>
  </span>
);

export const Monogram = ({ className = 'h-10 w-10', light = false }) => {
  const stroke = light ? '#F5F1EB' : '#354024';
  const accent = light ? '#CFBB99' : '#889063';
  return (
    <svg viewBox="0 0 120 120" className={className} fill="none" stroke={stroke} strokeWidth={light ? 2.6 : 2.2} strokeLinecap="square" aria-hidden="true" data-testid="ba-monogram">
      <path d="M34 26 V94" />
      <path d="M34 26 H54 a15 15 0 0 1 0 30 H34" />
      <path d="M34 56 H57 a19 19 0 0 1 0 38 H34" />
      <path d="M60 94 L76 26 L92 94" />
      <path d="M66 70 H86" stroke={accent} strokeWidth={light ? 1.6 : 1.4} />
      <path d="M22 102 H98" strokeWidth={light ? 1.2 : 1} />
      {!light && <path d="M28 106 H92" stroke="#CFBB99" strokeWidth=".6" />}
    </svg>
  );
};
